import React from 'react';

const HowToRun = () => {
    return (
        <div>
            <h2>How to Run the Code</h2>
            <p>
                Follow these steps to run the Deceptive Design Detector application:
            </p>
            <h3>Step-by-Step Instructions</h3>
            <ol>
                <li>
                    <strong>Install the Chrome Extension:</strong> 
                    Download the Chrome extension and pin it to your browser toolbar for easy access.
                </li>
                <li>
                    <strong>Access the Website:</strong> 
                    Navigate to the website on which you want to conduct the deceptive design analysis.
                </li>
                <li>
                    <strong>Launch the Extension:</strong> 
                    Click on the pinned Chrome extension icon to open the extension interface and start a new session by entering a session name.
                </li>
                <li>
                    <strong>Available Actions:</strong>
                    <ul>
                        <li><strong>Start:</strong> Begins the session with a stopwatch monitoring the duration.</li>
                        <li><strong>Inspect:</strong> Captures the entire webpage as a long screenshot including all scrollable areas.</li>
                        <li><strong>Capture:</strong> Takes a screenshot of the current visible portion of the webpage.</li>
                        <li><strong>Stop:</strong> Ends the session and halts all ongoing operations.</li>
                        <li><strong>Record:</strong> Records a video of the entire session documenting all UIs you visit during navigation.</li>
                    </ul>
                </li>
                <li>
                    <strong>View Captured Results:</strong>
                    All captured results such as screenshots or recordings will be displayed under the "Status" section and saved for further analysis.
                </li>
            </ol>
            <p>By following these steps, you can effectively capture and store UI data for further analysis of deceptive design patterns.</p>
        </div>
    );
};

export default HowToRun;
